import styled from 'styled-components';

export const Wrapper = styled.div`
  .modal-body {
    overflow-y: ${(props) => props.overFlowY};
    overflow-x: hidden;
  }
`;

export const Container = styled.div`
  width: 100%;
      
  .inputText{
    background-color: ${(props) => props.theme.colors.modalInputSearchBackgroundColor};
  }

  .tab-visible {
  }

  .tab-gone {
    display: none;
    overflow: hidden;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TitleGroup = styled.div`
  width: 100%;
  margin-bottom: 10px;
`;

export const Label = styled.div`
  color: ${(props) => props.theme.evolutiveConfig.labelColor};
  padding: 5px;
  font-size: 1.4em;
  margin-bottom: 10px;
`;

export const LabelSmall = styled.span`
  font-style: italic;
  color: inherit;
  margin-left: 5px;
  font-weight: 300;
`;

export const ItemsGroup = styled.div`
`;

export const FixedItem = styled.div`
  margin-bottom: 10px;
`;

export const DynamicItems = styled.div`
  // display: flex;
  // flex-direction: row;
  // justify-content: space-evenlys;
  margin-bottom: 10px;
  .MultiQuestionAwareCollapsibleOrderableList-Ui-BodySection {
    height: ${(props) => (props.bodySectionHeight ? props.bodySectionHeight : 'auto')};
  }
`;

export const ScoreZone = styled.div`
  width: 30%;
`;
